import { push } from '@lagunovsky/redux-react-router'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import Loader from '../Loader'
import './LoaderPopup.scss'
import hocLoaderPopup from './hocLoaderPopup'

function LoaderPopup({ loading, stopLoading }) {
    const MAX_LOADING_TIME = 60000
    const dispatch = useDispatch()
    useEffect(() => {
        let timer = 0
        if (loading) {
            timer = setTimeout(() => {
                stopLoading()
                dispatch(push(PAGE_NAME.ERROR))
            }, MAX_LOADING_TIME)
        }
        return () => {
            clearTimeout(timer)
        }
    }, [loading])

    if (!loading) {
        return
    }

    return (
        <div className={`loader-popup-bg `}>
            <Loader className={'scaleUp-loader'} />
        </div>
    )
}

export default hocLoaderPopup(LoaderPopup)
